var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.654 29.995h-2.683a2.764 2.764 0 0 1-2.65-2.037l-.582-2.1c-.26-.906-1.165-1.456-2.069-1.23l-2.1.518a2.757 2.757 0 0 1-3.071-1.326L1.14 21.493a2.792 2.792 0 0 1 .42-3.33l1.52-1.583a1.758 1.758 0 0 0 0-2.424l-1.52-1.583a2.827 2.827 0 0 1-.42-3.33L2.5 6.916c.613-1.067 1.875-1.616 3.07-1.293l2.101.518c.906.226 1.811-.29 2.069-1.229l.582-2.1C10.612 1.743 11.71.902 12.94.902h2.683c1.228 0 2.327.841 2.65 2.037l.582 2.101c.259.905 1.164 1.455 2.068 1.229l2.101-.518a2.757 2.757 0 0 1 3.071 1.326l1.357 2.327a2.792 2.792 0 0 1-.42 3.33l-1.52 1.583a1.758 1.758 0 0 0 0 2.424l1.52 1.583c.84.873 1.034 2.23.42 3.33l-1.357 2.327c-.614 1.067-1.875 1.616-3.07 1.293l-2.102-.518c-.905-.226-1.81.29-2.068 1.229l-.582 2.1c-.292 1.068-1.39 1.909-2.619 1.909zM14.297 11.57a3.89 3.89 0 0 0-3.879 3.88 3.89 3.89 0 0 0 3.879 3.878 3.89 3.89 0 0 0 3.879-3.879 3.89 3.89 0 0 0-3.88-3.879z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingGray);
export default __webpack_public_path__ + "static/media/settingGray.a57fa1785c13dce41444092bd66ce50f.svg";
export { ForwardRef as ReactComponent };